type CustomBorderIconProps = React.SVGProps<SVGSVGElement> & {
    style?: React.CSSProperties
}

const BorderLeftIcon = ({ style = {}, ...otherProps }: CustomBorderIconProps) => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 257 257'
        fill='currentColor'
        style={{
            display: 'inline-block',
            flexShrink: 0,
            ...style
        }}
        {...otherProps}>
        <rect className='st0' x='74.97' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='74.97' y='32.12' width='21.42' height='21.42' />
        <rect className='st0' x='74.97' y='117.79' width='21.42' height='21.42' />
        <rect className='st0' x='117.8' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='117.8' y='160.61' width='21.42' height='21.42' />
        <rect className='st0' x='160.63' y='117.79' width='21.42' height='21.42' />
        <path className='st0' d='M32.1,42.83v171.33c0,5.89,4.82,10.71,10.71,10.71s10.71-4.82,10.71-10.71V42.83c0-5.89-4.82-10.71-10.71-10.71s-10.71,4.82-10.71,10.71Z' />
        <rect className='st0' x='160.63' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='160.63' y='32.12' width='21.42' height='21.42' />
        <rect className='st0' x='117.8' y='117.79' width='21.42' height='21.42' />
        <rect className='st0' x='117.8' y='32.12' width='21.42' height='21.42' />
        <rect className='st0' x='117.8' y='74.96' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='160.61' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='117.79' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='32.12' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='74.96' width='21.42' height='21.42' />
    </svg>
)

export default BorderLeftIcon
